<script>
import {defineComponent} from 'vue'

export default defineComponent({
  permissions: [],
  name: "ActiveApiCalls",
  props: ['color'],
  computed: {
    activeApiCalls() {
      return this.$WfmApi.activeRequestCount.value + this.$BwfApi.activeRequestCount.value
    },
    spinnerColor(){
      return this.color || 'primary'
    }
  },
})
</script>

<template>
  <v-progress-circular indeterminate v-if="activeApiCalls>0"
                       :color="spinnerColor" size="35" width="5">{{ activeApiCalls }}</v-progress-circular>
</template>

<style scoped>

</style>